import React from "react";
import { Modal } from "@material-ui/core";
import { Box, TextField, Typography } from "@mui/material";

const DeleteDialogueBox = ({
  title= "Are you sure you want to delete this image?",
  open,
  close,
  cancel,
  deleteImage,
  ...rest
}) => {
    const style = {
        position: "absolute" ,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
    
        boxShadow: 24,
        p: 4,
      };
  return (
    <>
     <Modal
          open={open}
          onClose={close}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
              <Box sx={style}>
              <h6 style={{ fontWeight: "500", padding:"5px 0px 5px 0px" }}>
                  {title}
                </h6>
            <div className="pr-sm-4 pl-sm-4 pt-1">
                <div className="row justify-content-end no-gutters  ">
                <div className="col-auto">
              <button
                style={{marginRight:"-12px"}}
                className="btn btn-secondary btn-sm"
                type="button"
                onClick={cancel}
              >
                Cancel
              </button>
              </div>
              {/* <Link to="/"> */}
              <div className="col-auto">
              <button
               style={{marginRight:"10px"}}
                className="btn btn-danger btn-sm "
                type="button"
                onClick={deleteImage}
              >
                Delete
              </button>
              </div>
              {/* </Link> */}
            </div>
          </div>
         
          </Box>
        </Modal>
        </>
  );
};

export default DeleteDialogueBox;
